<template>
  <div class='hall-of-fame-base'>
    <header-base />
    <h1>HALL OF FAME</h1>
    <v-tabs
      background-color='red darken-1 accent-4'
      color='white'
      grow
      v-model='currTab'
    >
      <v-tab v-for='(segment, i) in segments' :key='i'>{{segment.name}}</v-tab>

      <v-tabs-items touchless v-model='currTab'>
        <v-tab-item v-for='(segment, i) in segments' :key='i'>
          <!-- TODO: add the event list and links to event brackets in the hall of fame page -->
          <v-container><points-ladder :segmentID='segment.segmentID' :seasonID='segment.seasonID'/></v-container>
        </v-tab-item>
      </v-tabs-items>
    </v-tabs>
  </div>
</template>

<script>
import HeaderBase from '@/components/TPC/Header/Base'
import PointsLadder from '@/components/TPC/Shared/PointsLadder'

export default {
  name: 'hall-of-fame-base',
  components: {
    HeaderBase,
    PointsLadder,
  },
  data () {
    return {
      currTab: 0,
      segments: [{
        name: 'CUBERSLIVE OPEN',
        events: ['3x3', '3BLD', '2x2', 'Pyraminx'],
        seasonID: 1,
        segmentID: 1,
      },
      {
        name: 'CLASH OF THE TITANS',
        events: ['3x3', '4x4', 'Skewb', '5x5'],
        seasonID: 1,
        segmentID: 2,
      }],
    }
  },
}
</script>
